import { TemplatePage } from './types';

const live_streaming_intro_page: TemplatePage = {
  header: {
    color: '#97DEF0',
    icon: 'images/video-templates/intro_outro.jpg',
    title: 'Live Stream Intro Video Templates',
    title_meta: '20+ Free Live Stream Intro Video Templates',
    description_meta:
      'Easily create a professional-looking branded intro for your live stream with Wave.video’s ready-to-edit video ' +
      'templates.',
    description:
      'Easily create a professional-looking branded intro for your live stream with these ready-to-edit video templates. ' +
      'Capture the attention of your viewers with a powerful intro from the very beginning of your live video.'
  },
  footer: {
    category: 'Live streaming intro',
    description:
      'With Wave.video’s broad range of easy-to-edit video templates, live stream intro videos take only a couple of ' +
      'minutes to make. Give your live streams a professional look and feel by simply choosing a template of your ' +
      'liking and customizing it to your taste and needs in no time. Simple and free! '
  },
  content: [
    {
      type: 'templates',
      title: 'Live Streaming Intro',
      search: { name: 'LiveIntro', tags: 'LiveIntro' }
    },
    {
      type: 'stocks',
      title: 'intro',
      search: { name: 'intro' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_intro_page;
